import { render, staticRenderFns } from "./IndividualCourseEnrollPanel.vue?vue&type=template&id=2b18ba61&scoped=true"
import script from "./IndividualCourseEnrollPanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseEnrollPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18ba61",
  null
  
)

export default component.exports